module.exports = __webpack_public_path__ + "img/Czech_Republic.3d25a9c8.png";